import { freeze } from 'immer';
import { MeasureDisplayFormatKind } from '../../../../utils/apollo/graphqlSchema';
import { AxisBoundType } from './types';
import { YAxisPosition } from '../../interfaces';

export const FUNNEL_CONVERSION_OPTIONS = freeze(
  [
    {
      label: 'Conversion',
      value: true,
      hint: 'Show conversion rate on Y-axis',
    },
    { label: 'Count', value: false, hint: 'Show count on Y-axis' },
  ],
  true,
);

export const CLUSTER_OPTIONS = freeze(
  [
    {
      label: 'Funnel',
      value: false,
      hint: 'Group bars by breakdown',
    },
    {
      label: 'Step',
      value: true,
      hint: 'Group bars by step',
    },
  ],
  true,
);

export const Y_AXIS_VISIBILITY_OPTIONS = freeze(
  [
    { label: 'Visible', value: true },
    { label: 'Hidden', value: false },
  ],
  true,
);

export const BOUND_TYPE_OPTIONS = freeze(
  [
    { label: 'Auto', value: AxisBoundType.Auto },
    { label: 'Truncate', value: AxisBoundType.Truncate },
    { label: 'Custom', value: AxisBoundType.Custom },
  ],
  true,
);

export const generateFormatOption = (currencySymbol: string) => {
  return freeze(
    [
      { label: '#', value: MeasureDisplayFormatKind.Number },
      { label: '%', value: MeasureDisplayFormatKind.Percent },
      { label: currencySymbol, value: MeasureDisplayFormatKind.Currency },
    ],
    true,
  );
};

export const getYAxisLabelByPosition = (
  position: YAxisPosition | undefined,
) => {
  return position === YAxisPosition.RIGHT ? 'Right' : 'Left';
};
